export default __webpack_public_path__ + "static/media/Jeep.242bff67.svg";